@import "../../../../shared/scss";

:host {
  @include pds-text-small;
  display: flex;
}
